/** Admin dashboard (React) — entrypoint. Gồm quản lý system_settings (E13-8). */
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.js";
import { initTheme } from "./lib/theme.js";
import "./styles/admin.css";

// Khôi phục theme (localStorage → system → light) TRƯỚC render để dark persist qua reload.
initTheme();

const el = document.getElementById("root");
if (el) {
  createRoot(el).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
